<template>
  <div>
    <div>
      <p
        class="item-tree2"
      >
        <!-- {{ itemData.title }} -->
        <template>
          <span>
            <a-form-item>
              <a-input
                v-decorator="[
                  `input_${itemData.index}_${itemData.key}`,
                  {
                    initialValue: itemData.title
                  }
                ]"
                :placeholder="itemData.name"
                style="width: 320px;"
                @change="changeVal"
              />
            </a-form-item>
            <a-checkbox
              :default-checked="itemData.ischecked"
              @change="onChange"
            >
              默认
            </a-checkbox>
          </span>
        </template>
        <span class="op-tool">
          <i
            class="edit-icon icon iconfont iconicon-test8"
            @click="delName"
          />
          <i
            class="edit-icon icon iconfont iconicon-test72"
          />
        </span>
      </p>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    datas: {
      type: Object,
      default () {
        return {}
      }
    },
    options: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      isShow: false,
      isTitShow: false
    }
  },
  computed: {
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    delName () {
      this.delLoop(this.datas.options, this.itemData.key)
      this.$emit('delTreeItem', this.datas.options)
    },
    delLoop (arr, key) {
      for (let i = 0; i < arr.length; i++) {
        if (key !== undefined && key === arr[i].key) {
          this.$set(arr[i], 'isshow', false)
          this.setShowFalse(arr, arr[i])
        }
        if (arr[i].children && arr[i].children.length) {
          this.delLoop(arr[i].children, key)
        }
      }
    },
    defaultLoop (arr, key, b) {
      for (let i = 0; i < arr.length; i++) {
        if (key !== undefined && key === arr[i].key) {
          // arr[i].isshow = false
          this.$set(arr[i], 'ischecked', b)
          this.$forceUpdate()
          if (b) {
            this.datas.defaultvalue.push(key)
          } else {
            this.datas.defaultvalue.splice(this.datas.defaultvalue.indexOf(key), 1)
          }
        }
        if (arr[i].children && arr[i].children.length) {
          this.defaultLoop(arr[i].children, key)
        }
      }
    },
    changeVal (e) {
      this.editShowname(this.datas.options, this.itemData.key, e.target.value)
    },
    onChange (e) {
      this.defaultLoop(this.datas.options, this.itemData.key, e.target.checked)
    },
    setShowFalse (arr, pele) {
      arr.forEach(item => {
        if (item.pid === pele.id && (pele.isshow === false)) {
          // item.isshow = false
          this.$set(item, 'isshow', false)
        }
        if (item.children) {
          this.setShowFalse(item.children, item)
        }
      })
    },
    editShowname (arr, key, val) {
      arr.forEach(item => {
        if (item.key === key) {
          // item.showname = val
          this.$set(item, 'showname', val)
        }
        if (item.children) {
          this.editShowname(item.children, key, val)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.item-tree2::v-deep {
  width: 100%;
  height: 32px;
  line-height: 32px;
  display:block;
  margin-left: -20px;
  padding-left: 20px;
  .ant-form-item-control-wrapper,.ant-input,.ant-form-item{
    width: 320px !important;
  }
}
.item-tree2:hover {
  background: #f4f7f9;
}
.item-tree2 .op-tool{
  display: none;
  // margin: 0 16px;
  .edit-icon {
    margin-left: 10px;
    font-size: 16px;
    color: #d6d6d6;
  }
  .ant-form-item-control {
    line-height: 32px;
  }
  .ant-form-item {
    margin-right: 0 !important;
  }
  .ant-btn{
    margin-right: 0;
    margin-left:16px;
  }
}
.item-tree2:hover .op-tool{
  display: inline-block;
}
.add-tree-item-form::v-deep {
  position: relative;
  z-index: 5;
}
</style>
